import React, { useState, useEffect } from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import ScrollReveal from "scrollreveal";
const VedanthaClasses = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      
    });
    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
    })
  }, []);

  const talks = [
    {
      id: 657,
      title: "GĪTĀ",
      image:
        "https://sastraprakasika.com/wp-content/uploads/2019/02/gita-150x150.png",
      topics: 7,
      volumes: 71,
    },
    {
      id: 692,
      title: "UPANIṢADS",
      image:
        "https://sastraprakasika.com/wp-content/uploads/2019/02/ubanish-150x150.png",
      topics: 13,
      volumes: 58,
    },
    {
      id: 705,
      title: "BRAHMASŪTRAS",
      image:
        "https://sastraprakasika.com/wp-content/uploads/2019/02/brahma-150x150.png",
      topics: 1,
      volumes: 39,
    },
    {
      id: 717,
      title: "ŚAṄKARA-BHĀṢYAM",
      image:
        "https://sastraprakasika.com/wp-content/uploads/2019/02/shakara-150x150.png",
      topics: 11,
      volumes: 137,
    },
    {
      id: 743,
      title: "OTHER TEXTS",
      image:
        "https://sastraprakasika.com/wp-content/uploads/2019/02/others-150x150.png",
      topics: 57,
      volumes: 303,
    },
  ];

  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      // alignItems: "center",
      flexWrap: "wrap",
      gap: "20px",
      margin: "0 auto",
      padding: "20px",
    },
    card: {
      backgroundColor: "#F5F5F5",
      textAlign: "center",
      margin: "10px",
      flex: "1 1 calc(33% - 40px)",
      minWidth: "250px",
      maxWidth: "250px",
      borderRadius: "10px",
      overflow: "hidden",
      transition: "box-shadow 0.3s ease-in-out",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s ease-in-out",
    },
    label: {
      marginTop: "10px", // Space between image and label
      fontSize: "16px",
      color: "#495057",
    },
    cardHover: {
      boxShadow: "0 4px 15px #8C3A00", // Orange box-shadow on hover
      transform: "scale(1.01)",
    },
    media: {
      height: "200px",
      width: "100%",
      objectFit: "cover",
      transition: "transform 0.3s ease-in-out",
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px 20px",
    },
    textOrange: {
      color: "orange",
    },
  };

  return (
    <div
      className="container-sm"
      style={{ marginTop: "20px", minHeight: "100vh" }}
    >
      <div style={styles.container} className="reveal">
        {talks.map((talk, index) => (
          <Card
            key={talk.id}
            style={{
              ...styles.card,
              ...(hoveredIndex === index ? styles.cardHover : {}),
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            className="reveal"
          >
            <CardMedia
              component="img"
              image={talk.image}
              alt={talk.title}
              style={{
                ...styles.media,
              }}
            />
            <CardContent>
              <Typography variant="h6" component="div" style={styles.label}>
                {talk.title}
              </Typography>
              <div style={styles.content}>
                <Typography variant="body2" color="text.secondary">
                  No of Topics:
                  <span style={styles.textOrange}> {talk.topics}</span>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Volumes:
                  <span style={styles.textOrange}> {talk.volumes}&emsp;</span>
                </Typography>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default VedanthaClasses;
